import React from 'react'
import Navber from '../../../Components/Navber.jsx'
import HeroSection from './HeroSection.jsx'
import PopularDestinations from './PopularDestinations.jsx'
import TrendingHoneymoonPackages from './TrendingHoneymoonPackages.jsx'
import HandpickedRomanticStays from './HandpickedRomanticStays.jsx'
import HoneymoonTestimonials from './HoneymoonTestimonials.jsx'

function MainLayout() {
  return (
    <div>
        <Navber/>
        <HeroSection/>
        <PopularDestinations/>
        <TrendingHoneymoonPackages/>
        <HandpickedRomanticStays/>
        {/* <HoneymoonTestimonials/> */}
       
    </div>
  )
}

export default MainLayout